import styled from "styled-components";
export const HeaderContainer = styled.header`
  background-color: ${({ theme }) => theme.colors.footerBackground};
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  box-shadow: 0px 0px 16px rgb(0 0 0 / 30%);
  z-index: 100;
  .content {
    display: flex;
    align-items: center;
    position: relative;
    .logo {
      height: 60px;
      cursor: pointer;
      padding-bottom: 8px;
    }
    .menu-icon {
      display: none;
    }
    .overlay {
      display: none;
    }
    .slogan {
      font-size: 18px;
      font-weight: 600;
      margin-right: 16px;
      line-height: 22px;
      color: ${({ theme }) => theme.colors.btnPrimaryText};
    }
    .menu {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      li {
        margin-right: 20px;
        position: relative;
        &:before {
          content: ".";
          font-size: 24px;
          position: absolute;
          right: -13px;
          top: -8px;
        }
        &:first-child {
          &:before {
            display: none;
          }
        }
        a {
          color: #fff;
        }
      }
    }
    .panel-link {
      position: absolute;
      left: 0;
      border: solid 1px #fff;
      border-radius: 5px;
      padding: 4px 8px 2px 8px;
      bottom: 14px;
      cursor: pointer;
      color: #fff;
    }
  }
  @media only screen and (max-width: 760px) {
    padding-bottom: 0;
    position: sticky;
    top: 0;
    .content {
      justify-content: space-between;
      position: relative;
      flex-direction: row-reverse;
      align-items: center;
      .logo {
        height: 48px;
      }
      .menu-icon {
        display: block;
        font-size: 24px;
      }
      .overlay {
        display: block;
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        top: 0;
        right: ${({ menuStatus }) => (menuStatus ? "0" : "-100%")};
        transition: 0.3s all;
        z-index: 99;
      }
      .slogan {
        display: none;
      }
      .menu {
        position: fixed;
        width: 75%;
        height: 100%;
        background: #fff;
        top: 0;
        z-index: 100;
        padding: 32px 8px;
        flex-direction: column;
        right: ${({ menuStatus }) => (menuStatus ? "0" : "-75%")};
        transition: 0.3s all;
        li {
          margin-bottom: 16px;
          &:before {
            display: none;
          }
          a {
            color: #221C35;
          }
        }
      }
      .panel-link {
        left: auto;
        right: 36px;
        bottom: 8px;
      }
    }
  }
`;
